import React from 'react';
import arrow from '../../../assets/images/arrow-left.svg';
import styles from './filtersMobilePanel.module.scss';

export default function FiltersMobilePanel({ close, isOpen, children }) {
  return (
    <div className={`${styles.filtersMobilePanel} ${isOpen ? styles.open : ''}`}>
      <div className={styles.header}>
        <button
          type='button'
          className={styles.close}
          onClick={() => close()}
        >
          <img src={arrow} alt="retour" />
          <span>Retour</span>
        </button>
        <h2>Filtres</h2>
      </div>
      <div className={styles.content}>
        {children}
      </div>
      <button
        type="button"
        className={styles.submit}
        onClick={() => close()}
      >
        Appliquer les filtres
      </button>
    </div>
  )
}